import { useState, useEffect } from 'react';
import api from '@/api';

interface HealthState {
  isHealthy: boolean;
  isLoading: boolean;
  error: string | null;
}

const useHealthCheck = () => {
  const [healthState, setHealthState] = useState<HealthState>({
    isHealthy: true,
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    const checkHealth = async () => {
      try {
        await api.get('/health');
        setHealthState({ isHealthy: true, isLoading: false, error: null });
      } catch (error: any) {
        console.error('Health check failed:', error.response?.data);

        // Формуємо більш детальне повідомлення про помилку
        let detailedError = 'Service is temporarily unavailable. Please try again later.';
        const errorDetails = error.response?.data?.error;

        if (errorDetails && typeof errorDetails === 'object') {
          const errorMessages = Object.entries(errorDetails).map(([service, details]) => {
            const typedDetails = details as { status?: string; message?: string };
            return `${service} (${typedDetails.status}): ${typedDetails.message}`;
          });

          if (errorMessages.length > 0) {
            detailedError = errorMessages.join(', ');
          }
        }

        setHealthState({ isHealthy: false, isLoading: false, error: detailedError });
      }
    };

    checkHealth();
  }, []);

  return healthState;
};

export default useHealthCheck;
